import React, { useEffect, useState } from "react";
import { theme, ConfigProvider } from "antd";

const { defaultAlgorithm } = theme;

// Get the computed value of the CSS variable
const getComputedPrimaryColor = () => {
  return getComputedStyle(document.documentElement).getPropertyValue("--primary-color").trim() || "#7732EF";
};

export const DynamicThemeProvider = ({ children }) => {
  const [currentTheme, setCurrentTheme] = useState({
    algorithm: defaultAlgorithm,
    token: {
      colorPrimary: getComputedPrimaryColor(),
      colorLink: getComputedPrimaryColor(),
      colorLinkHover: getComputedPrimaryColor(),
      colorLinkActive: getComputedPrimaryColor(),
    },
  });

  useEffect(() => {
    const observer = new MutationObserver(() => {
      setCurrentTheme({
        algorithm: defaultAlgorithm,
        token: {
          colorPrimary: getComputedPrimaryColor(),
          colorLink: getComputedPrimaryColor(),
          colorLinkHover: getComputedPrimaryColor(),
          colorLinkActive: getComputedPrimaryColor(),
        },
      });
    });

    observer.observe(document.documentElement, {
      attributes: true,
      attributeFilter: ["style"],
    });

    return () => observer.disconnect();
  }, []);

  return <ConfigProvider theme={currentTheme}>{children}</ConfigProvider>;
};

export default DynamicThemeProvider;
